import { CommonModule } from "@angular/common";
import { NgModule, LOCALE_ID } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { provideNgxMask, NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';
import { TypeaheadModule } from "ngx-bootstrap/typeahead";
import { SimpleHtmlModule } from "src/app/components/simple-html/simple-html.module";
import { PageNewOrderComponent } from "./page-new-order/page-new-order.component";
import { BrowserModule } from "@angular/platform-browser";
import { AppRoutingModule } from "src/app/app.routes";
import { HttpClientModule } from "@angular/common/http";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
// import { NgxMaskModule } from "ngx-mask";
import { PaginationModule } from "ngx-bootstrap/pagination";
import { SweetAlert2Module } from "@sweetalert2/ngx-sweetalert2";
import { ToastrModule } from "ngx-toastr";
import { NewOrderService } from "./service/new-order.service";
import localePt from "@angular/common/locales/pt";
import { defineLocale } from "ngx-bootstrap/chronos";
import { ptBrLocale } from "ngx-bootstrap/locale";
import { registerLocaleData } from "@angular/common";
import { TypeaheadComponent } from "src/app/components/typeahead/typeahead.component";
const customLocale = {
  ...ptBrLocale,
  weekdays: [$localize`Domingo`,$localize`Segunda-feira`,$localize`Terça-feira`,$localize`Quarta-feira`,$localize`Quinta-feira`,$localize`Sexta-feira`,$localize`Sábado`],
  weekdaysShort: [$localize`Dom`,$localize`Seg`,$localize`Ter`,$localize`Qua`,$localize`Qui`,$localize`Sex`,$localize`Sáb`],
  months: [
    $localize`Janeiro`,$localize`Fevereiro`,$localize`Março`,$localize`Abril`,$localize`Maio`,$localize`Junho`,
    $localize`Julho`,$localize`Agosto`,$localize`Setembro`,$localize`Outubro`,$localize`Novembro`,$localize`Dezembro`
  ],
  monthsShort: [$localize`Jan`,$localize`Fev`,$localize`Mar`,$localize`Abr`,$localize`Mai`,$localize`Jun`,$localize`Jul`,$localize`Ago`,$localize`Set`,$localize`Out`,$localize`Nov`,$localize`Dez`],
};

defineLocale("pt-custom", customLocale);
registerLocaleData(localePt, "pt-BR");
@NgModule({
  declarations: [
    PageNewOrderComponent,
    TypeaheadComponent
  ],
  imports: [
    CommonModule,
    AppRoutingModule,
    FormsModule,
    SimpleHtmlModule,
    BrowserModule,
    ReactiveFormsModule,
    NgxMaskDirective,
    NgxMaskPipe,
    BsDatepickerModule.forRoot(),
    // TypeaheadModule.forRoot(),
    TooltipModule.forRoot(),
    HttpClientModule,
    BrowserAnimationsModule,
    // HttpModule,
    // NgxMaskModule.forRoot(),
    // PaginationModule.forRoot(),
    SweetAlert2Module.forRoot(),
    ToastrModule.forRoot({
      positionClass: "toast-bottom-right",
    }),
  ],
  providers: [provideNgxMask(),NewOrderService, { provide: LOCALE_ID, useValue: "pt-BR" }],
})
export class OrderModule {}
